import styled from 'styled-components'
import { InputStyle } from './input'
import { fontSizes } from '../../../styles/theme'

const Textarea = styled.textarea`
  ${InputStyle}
  height: 10rem;
  min-height: 5rem;
  resize: vertical;

  font-size: ${fontSizes.size500};
  line-height: 1.25em;

  padding: ${props => props.theme.spacing.base300} ${props => props.theme.spacing.base400};
`

export default Textarea
